/* ============================================================
   SOCIAL IRONY — product-drawer.js
   Loads the product page's drawer section into the drawer shell, then
   hands variant selection over to the shared product-variant logic.
   ============================================================ */

(function () {
  'use strict';

  const qs = window.SI.qs;
  const qsa = window.SI.qsa;

  const drawer = qs('[data-si-product-drawer]');
  const body = qs('[data-si-product-drawer-body]');
  const label = qs('[data-si-product-drawer-label]');
  if (!drawer || !body) return;

  const cache = new Map();
  let controller = null;

  const showLoading = () => {
    body.innerHTML =
      '<div class="si-drawer-loading si-stack si-stack--sm" aria-hidden="true">' +
      '<span class="si-drawer-loading__block"></span>' +
      '<span class="si-drawer-loading__block"></span>' +
      '<span class="si-drawer-loading__block si-drawer-loading__block--short"></span>' +
      '</div>';
  };

  const loadProduct = (url) => {
    if (cache.has(url)) {
      body.innerHTML = cache.get(url);
      init();
      return;
    }

    if (controller) controller.abort();
    controller = new AbortController();
    showLoading();

    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=product-drawer-content', {
      signal: controller.signal,
      headers: { Accept: 'text/html' }
    })
      .then((response) => {
        if (!response.ok) throw new Error(window.SI.strings.error);
        return response.text();
      })
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const content = parsed.querySelector('[data-si-drawer-content]');
        const markup = content ? content.innerHTML : html;
        cache.set(url, markup);
        body.innerHTML = markup;
        init();
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        body.innerHTML =
          '<p class="si-form-status si-form-status--error">' + window.SI.strings.error + '</p>' +
          '<a class="si-btn si-btn--outline si-btn--full" href="' + url + '">View product</a>';
      });
  };

  /* ---------- Variant + quantity handling inside the drawer ---------- */
  const init = () => {
    const form = qs('[data-si-product-form]', body);
    if (!form) return;

    const variantInput = qs('[data-si-variant-id]', form);
    const priceTarget = qs('[data-si-drawer-price]', body);
    const submitButton = qs('[data-si-atc]', form);
    const variants = window.SI.productVariants ? window.SI.productVariants[form.dataset.productHandle] : null;

    if (!variants || !variantInput) return;

    const syncVariant = () => {
      const selected = qsa('input[data-si-option], select[data-si-option]', form);
      const chosen = selected.map((el) => el.value);

      const match = variants.find((variant) => {
        if (variant.options.length !== chosen.length) return false;
        return variant.options.every((option, index) => option === chosen[index]);
      });

      if (!match) {
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = window.SI.strings.unavailable;
        }
        return;
      }

      variantInput.value = match.id;

      if (priceTarget) {
        priceTarget.innerHTML = window.SI.formatMoney(match.price, window.SI_MONEY_FORMAT);
      }

      if (submitButton) {
        submitButton.disabled = !match.available;
        submitButton.textContent = match.available
          ? window.SI.strings.addToCart
          : window.SI.strings.soldOut;
      }

      const compare = qs('[data-si-compare-price]', body);
      if (compare) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compare.innerHTML = '<s>' + window.SI.formatMoney(match.compare_at_price, window.SI_MONEY_FORMAT) + '</s>';
        } else {
          compare.innerHTML = '';
        }
      }
    };

    qsa('input[data-si-option], select[data-si-option]', form).forEach((el) => {
      el.addEventListener('change', syncVariant);
    });

    syncVariant();
  };

  document.addEventListener('si:product:open', (event) => {
    const detail = event.detail || {};
    if (label && detail.handle && window.SI.productTitles && window.SI.productTitles[detail.handle]) {
      label.textContent = window.SI.productTitles[detail.handle];
    }
    if (detail.url) loadProduct(detail.url);
  });
})();
